import { put, select, takeLatest } from 'redux-saga/effects'
import { getSignersSelector } from '../selectors'
import { setSignerList } from '../store/completeChart.actions'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { ISignerState } from '../store/completeChart.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getCurrentDateTimeHH24FormatByTimeZone } from '../../../utilities/dateTime.util'
import { ConfigurationsConstants } from '../../configurations/store/configurations.constants'

export function* setVerifyCrew() {
  const signerState: ISignerState = yield select(getSignersSelector)
  const { verified, signer, signerList } = signerState
  const selectedVerified = signerList.filter((u) => u.key === signer?.key)
  const currentDate = getCurrentDateTimeHH24FormatByTimeZone(ConfigurationsConstants.DEFAULT_TIMEZONE)
  if (selectedVerified && selectedVerified.length) {
    selectedVerified[0].verified = verified
    selectedVerified[0].dt = currentDate
    yield put(setSignerList(signerList))
  }
}
export function* setVerifyCrewSaga() {
  yield takeLatest([CompleteChartConstants.SET_VERIFY_CREW], performWithMutexHOG, setVerifyCrew)
}
